<template>
  <div>
    <div v-if="viewForm">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-4"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['settings_change_password']}}</h1>
      <p class="textcolor">
        <input
          type="checkbox"
          id="uppercase"
          onclick="return false;"
          :checked="new RegExp('[A-Z]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_uppercase']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="lowercase"
          onclick="return false;"
          :checked="new RegExp('[a-z]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_lowercase']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="number"
          onclick="return false;"
          :checked="new RegExp('[0-9]').exec(password+'')"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_number']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="minlen"
          onclick="return false;"
          :checked="(password+'').trim().length >= 8"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_length']}}
      </p>
      <p class="textcolor">
        <input
          type="checkbox"
          id="pwequal"
          onclick="return false;"
          :checked="(password+'').trim().length > 0 && password+'' == password2+''"
        />
        &nbsp;{{LanguageStrings[DisplayLanguage]['register_pwmatch']}}
      </p>
      <form id="passwordform" onsubmit="return false;" class="mt-4">
        <div class="form-group">
          <label
            for="form_password"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['settings_new_password']}}</label>
          <input
            type="password"
            autocomplete="password"
            class="form-control"
            name="form_password"
            v-model="password"
          />
        </div>
        <div class="form-group">
          <label
            for="form_password2"
            v-bind:style="{ color: Company.CI_Textcolor }"
          >{{LanguageStrings[DisplayLanguage]['settings_new_password2']}}</label>
          <input
            type="password"
            autocomplete="password"
            class="form-control"
            name="form_password2"
            v-model="password2"
            v-on:keyup.enter="changePassword()"
          />
        </div>
        <div>
          <input
            class="btn btn-success"
            type="button"
            :value="LanguageStrings[DisplayLanguage]['settings_change_password']"
            :disabled="!canChange"
            @click="changePassword()"
          />
        </div>
        <input type="hidden" name="lang" :value="DisplayLanguage"/>
      </form>
    </div>
    <div v-if="showOK">
      <h1
        v-bind:style="{ color: Company.CI_Headlinecolor }"
        class="mb-0"
        align="center"
      >{{LanguageStrings[DisplayLanguage]['changepw_successful']}}</h1>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ResetPasswordDefault",
  components: {
    //HelloWorld
  },
  data: function() {
    return {
      viewForm: true,
      password: "",
      password2: "",
      showOK: false
    };
  },
  mounted: function() {

  },
  computed: {
    canChange: function() {
      if (new RegExp("[A-Z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[a-z]").exec(this.password + "") == null) {
        return false;
      }
      if (new RegExp("[0-9]").exec(this.password + "") == null) {
        return false;
      }
      if ((this.password + "").trim().length < 8) {
        return false;
      }
      if (
        (this.password + "").trim().length == 0 ||
        this.password + "" != this.password2 + ""
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    changePassword: function() {
      if(!this.canChange)
      {
        return false;
      }
      this.$parent.errortext = null;
      var self = this;
      axios
        .post(
          this.GS.Endpoint + "/v2/passwordchange/" + this.GS.RequestCode,
          this.form2JSON(document.getElementById("passwordform")),
          {}
        )
        .then(function(response) {
            self.viewForm = false;
            self.showOK = true;
        })
        .catch(function(response) {
          //console.log(response);
          if (response.response == undefined) {
            self.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.errortext = "sessionexpired";
            return;
          }
          self.$parent.errortext = "internalservererror";
        });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
h2 {
  font-size: 15px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
input {
  font-size: 13px;
}

p {
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>
